import DrawerBottom from 'components/landing/SubscriptionDrawer/DrawerBottom'
import DrawerTop from 'components/landing/SubscriptionDrawer/DrawerTop'

const DrawerContent = props => (
  <>
    <DrawerTop { ...props } />
    <DrawerBottom { ...props } />
  </>
)

export default DrawerContent
